import { Theme } from '@24i/nxg-sdk-photon/src';
import { Breakpoint } from '@24i/nxg-sdk-smartott/src/utils/styles/constants';

import { BannerCarouselStyles } from './types';
import { RESPONSIVE_CONTAINER_HEIGHT } from './constants';

const getBannerCarouselStyles = (theme: Theme, isLandscape: boolean): BannerCarouselStyles => ({
    indicator: {
        width: '100%',
        height: '100%',
    },
    pagination: {
        minHeight: 32,
        bottom: 64,
        right: 80,
        minWidth: 132,
        zIndex: 101,
        position: 'absolute',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        borderRadius: 16,
        [`@media (min-width: ${Breakpoint.XL}px)`]: {
            bottom: 250,
        },
        ...(!isLandscape && {
            [`@media (max-width: ${Breakpoint.MD}px)`]: {
                right: 8,
                bottom: 30,
            },
        }),
    },
    paginationInteractable: {
        width: 'auto',
        minWidth: 24,
        height: 24,
        justifyContent: 'center',
        alignItems: 'center',
    },
    dot: {
        width: 3,
        height: 3,
        borderRadius: 1,
        backgroundColor: theme.color.contrast3,
    },
    activeDot: {
        width: 8,
        height: 8,
        borderRadius: 3,
        backgroundColor: theme.color.contrast1,
    },
    hoveredDot: {
        width: 8,
        height: 8,
        borderRadius: 3,
        backgroundColor: theme.color.contrast3,
    },
    navigationLeftArrow: {
        left: 0,
    },
    navigationRightArrow: {
        right: 0,
    },
    navigationArrowWrapper: {
        top: '30%',
        zIndex: 101,
        position: 'absolute',
        width: 48,
        height: 200,
        justifyContent: 'center',
        alignItems: 'center',
    },
    customContainer: {
        height: isLandscape ? RESPONSIVE_CONTAINER_HEIGHT.L : RESPONSIVE_CONTAINER_HEIGHT.M,
        ...(isLandscape && {
            [`@media (max-width: ${Breakpoint.XL}px)`]: {
                height: RESPONSIVE_CONTAINER_HEIGHT.M,
                marginBottom: -20,
            },
        }),
        [`@media (min-width: ${Breakpoint.XL}px)`]: {
            marginBottom: -210,
        },
    },
    singleItemContainer: {
        height: isLandscape ? RESPONSIVE_CONTAINER_HEIGHT.L : RESPONSIVE_CONTAINER_HEIGHT.M,
        ...(isLandscape && {
            [`@media (max-width: ${Breakpoint.XL}px)`]: {
                height: RESPONSIVE_CONTAINER_HEIGHT.M,
                marginBottom: -20,
            },
        }),
        [`@media (min-width: ${Breakpoint.XL}px)`]: {
            marginBottom: -240,
        },
    },
});

export default getBannerCarouselStyles;
